import { Button } from "@material-ui/core";
import React from "react";
import FeeSectionCss from "./style";

const FeeSection = () => {
  return (
    <FeeSectionCss>
      <div className="wrapper">
        <div className="left">
          <div className="title">Transaction Fee</div>
          <div className="stat">
            <h3>10%</h3>
            <p>Fee Per Transaction</p>
          </div>
          <div className="buttons">
            <Button
              className="leftButton"
              style={{ textTransform: "none" }}
              variant="contained"
              onClick={() =>
                window.open(
                  "https://bscscan.com/tx/0x74991b748304dfc3c8c5f47dea032169037e52f1a0fac945178be1145c120750",
                  "_blank"
                )
              }
            >
              <span>Burnt Tokens</span>
            </Button>
            <Button
              style={{ textTransform: "none" }}
              variant="contained"
              className="rightButton"
            >
              <span>Liquidity Tokens</span>
            </Button>
          </div>
          <div className="text">
            *These numbers and percentages are starting values and approximate.
            Actual values will change over time due to the nature of reflection
            rewards and fertilized tokens.
          </div>
        </div>

        <div className="right">
          <div className="up">
            <div className="header">6%</div>
            <div className="subheader">
              Reflection rewards proportionally given back to CEFA holders
            </div>
            <div className="text">
              <ul style={{ listStyle: "disc" }}>
                <li>
                  <b>0.75%</b>: dividends proportionally back to CETO Blockchain
                  Family holders
                </li>
                <li>
                  <b>1.2%</b>: to the Fertilizer Bag account (commonly known as
                  burnt)
                </li>
                <li>
                  <b>4%</b>: automatically compounded into CEFA holders’
                  accounts
                </li>
              </ul>
            </div>
          </div>
          <div className="down">
            <div className="header">4%</div>
            <div className="subheader">Providing Liquidity</div>
            <div className="text">
              <ul style={{ listStyle: "disc" }}>
                <li>
                  <b>2%</b> each automatically locked into a CEFA-BNB liquidity
                  pool on PancakeSwap
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mobile">
          <div className="top_mob">
            <div className="title_mob">Transaction Fee</div>
            <div className="subtitle">
              <h3>10%</h3>
              <p>Fee Per Transaction</p>
              <br />
            </div>
            <div className="buttons">
              <Button
                style={{ textTransform: "none" }}
                variant="contained"
                className="leftButton"
                onClick={() =>
                  window.open(
                    "https://bscscan.com/tx/0x74991b748304dfc3c8c5f47dea032169037e52f1a0fac945178be1145c120750",
                    "_blank"
                  )
                }
              >
                <span>Burnt Tokens</span>
              </Button>
              <Button
                style={{ textTransform: "none" }}
                variant="contained"
                className="rightButton"
              >
                <span>Liquidity Tokens</span>
              </Button>
            </div>
          </div>
          <div className="middle_mob">
            <div className="up">
              <div className="header">6%</div>
              <div className="subheader">
                Reflection rewards proportionally given back to CEFA holders
              </div>
              <div className="text">
                <ul style={{ listStyle: "disc" }}>
                  <li>
                    <b>0.75%</b>: dividends proportionally back to CETO
                    Blockchain Family holders
                  </li>
                  <li>
                    <b>1.2%</b>: to the Fertilizer Bag account (commonly known
                    as burnt)
                  </li>
                  <li>
                    <b>4%</b>: automatically compounded into CEFA holders’
                    accounts
                  </li>
                </ul>
              </div>
            </div>
            <div className="down">
              <div className="header">4%</div>
              <div className="subheader">Providing Liquidity</div>
              <div className="text">
                <ul style={{ listStyle: "disc" }}>
                  <li>
                    <b>2%</b> each automatically locked into a CEFA-BNB
                    liquidity pool on PancakeSwap
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FeeSectionCss>
  );
};

export default FeeSection;
